import React from 'react'
import Lottie from 'react-lottie';
import  animationData from './loading.json'
 
export default class LoadingComponent extends React.Component<{}> {
 
  constructor(props:any) {
    super(props);
    
  }
 
  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
 
    return <div>
      <Lottie options={defaultOptions}
              height={50}
              width={50}
              />
      
    </div>
  }
}